import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DisplayModes } from 'services/webedi/types';
import { SenderEnvelopeDTO } from 'support/types';
import { WebEDIMessageErrorBanner } from 'components/WebEDI/WebEDIMessageErrorBanner/WebEDIMessageErrorBanner';

type SenderEnvelopeErrorBannerProps = {
  senderEnvelope: Pick<SenderEnvelopeDTO, 'id' | 'blockingError'>;
};

export const SenderEnvelopeErrorBanner: FC<SenderEnvelopeErrorBannerProps> = ({ senderEnvelope }) => {
  const { t } = useTranslation();
  const blockingError = senderEnvelope.blockingError;

  if (!blockingError) {
    return null;
  }

  return (
    <WebEDIMessageErrorBanner
      mode={DisplayModes.view}
      blockingError={{
        ...blockingError,
        title: blockingError.title || t('transactions:show.senderEnvelope.defaultError.title'),
        description: blockingError.description || t('transactions:show.senderEnvelope.defaultError.description'),
      }}
    />
  );
};
